import { TFunction } from 'next-i18next';

export const getScreenReaderText = (
  hasReacted: boolean,
  reactionCount: number,
  isReactingTo: string,
  t: TFunction
): string => {
  switch (isReactingTo) {
    case 'comment':
      return hasReacted
        ? `${t(
            'components-reactionButton-remove_heart_from_comment_sr_text',
            'Unlike comment.'
          )} ${getTotalNumberOfReactionsString(reactionCount, t)}`
        : `${t(
            'components-reactionButton-react_with_heart_to_comment_sr_text',
            'Like comment.'
          )} ${getTotalNumberOfReactionsString(reactionCount, t)}`;
    default:
      return hasReacted
        ? `${t(
            'components-reactionButton-remove_heart_from_post_sr_text',
            'Unlike post.'
          )} ${getTotalNumberOfReactionsString(reactionCount, t)}`
        : `${t(
            'components-reactionButton-react_with_heart_to_post_sr_text',
            'Like post.'
          )} ${getTotalNumberOfReactionsString(reactionCount, t)}`;
  }
};

function getTotalNumberOfReactionsString(reactionCount: number, t: TFunction): string {
  return t(
    'components-reactionButton-total_reactions_sr_text',
    'The total number of reactions for this item is {{reactionCount}}.',
    {
      reactionCount,
    }
  );
}
